<template>
    <div>
        <h3>Send a Message</h3>
        <el-form
            ref="form"
            :model="form"
            label-position="left"
            label-width="110px"
        >
            <el-form-item label="To" size="small" :v-if="to">
                <el-tooltip placement="bottom" v-if="toField.length >= 200">
                    <div slot="content">{{ toField }}</div>
                    <el-button>To Selected Users ></el-button>
                </el-tooltip>
                <div v-if="toField.length < 200">
                    {{ toField }}
                </div>
            </el-form-item>
            <el-form-item label="From" size="small">
                <el-select
                    v-model="form.from"
                    placeholder="select email sender"
                >
                    <el-option label="Practice" value="practice"></el-option>
                    <el-option label="Me" value="me"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Reply to" size="small">
                <el-select
                    v-model="form.replyTo"
                    placeholder="select recipient of reply"
                >
                    <el-option label="Practice" value="practice"></el-option>
                    <el-option label="Me" value="me"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Delivery Type" size="small">
                <el-select
                    v-model="form.deliveryType"
                    placeholder="select delivery type"
                >
                    <el-option label="Email" value="email"></el-option>
                    <el-option
                        v-if="this.sendUserSurvey == ''"
                        label="Text"
                        value="text"
                    ></el-option>
                    <el-option
                        v-if="this.sendUserSurvey == ''"
                        label="Push Notification"
                        value="push"
                    ></el-option>
                    <el-option label="System Inbox" value="inbox"></el-option>
                    <el-option
                        label="System Inbox + Brief Email"
                        value="system"
                    ></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <el-form ref="form" :model="form">
            <el-form-item label="Subject">
                <el-input v-model="form.subject"></el-input>
            </el-form-item>
            <el-form-item label="Message" size="auto">
                <div class="insertTokenContainer">
                    <p class="insertTokenLabel">Insert Token:</p>
                    <el-select
                        v-model="currentToken"
                        placeholder="Select Token"
                    >
                        <el-option
                            v-for="token in tokens"
                            :key="token.value"
                            :value="token.value"
                            :label="token.label"
                        >
                        </el-option>
                    </el-select>
                    <el-button @click="insertToken">Insert</el-button>
                </div>
                <TextEditor
                    ref="textEditor"
                    v-model="form.content"
                    :message="this.getTextEditorContent()"
                />
            </el-form-item>
            <input
                type="file"
                id="file"
                ref="file"
                v-on:change="handleFileUpload()"
                style="display: none"
                multiple="multiple"
            />
            <el-form-item>
                <div class="fileDisplayDiv">
                    <el-button type="primary" @click="sendMessage"
                        >Send</el-button
                    >
                    <el-button
                        v-if="
                            this.form.deliveryType == 'email' ||
                            this.form.deliveryType == 'inbox' ||
                            this.form.deliveryType == 'system'
                        "
                        type="primary"
                        @click="attachFile()"
                        >Attach files</el-button
                    >
                    <div class="col-sm-8">
                        <div class="row">
                            <div
                                v-for="(item, index) in fileLists"
                                :key="index"
                            >
                                <div class="divblock">
                                    <i
                                        class="
                                            fa fa-times
                                            ml-2
                                            text-danger text-right
                                        "
                                        title="Remove attachment"
                                        aria-hidden="true"
                                        @click="RemoveFile(index)"
                                    ></i
                                    >{{ item.name }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-form-item>
        </el-form>
        <el-dialog
            :visible.sync="templateModal"
            :center="true"
            :append-to-body="true"
            width="25%"
        >
            <MesasgeTemplate
                :Msgtemplates="templates"
                @sel-template="selectedTemplate"
                :noRecordMessage="errorMessage"
                @delete-template="DeleteMessagingTemplate"
                @refreshTempList="regreshTemplateListData"
            ></MesasgeTemplate>
        </el-dialog>
    </div>
</template>
<script>
import TextEditor from "@/components/UIComponents/TextEditor.vue";
import MesasgeTemplate from "@/components/Dashboard/Views/MessagingTemplate/MessageTemplatesForEmail.vue";
import Messagingtemplates from "@/services/MessagingTemplate/MessagingTemplateServices.js";
// import 'element-tiptap/lib/index.css';
export default {
    components: {
        TextEditor,
        MesasgeTemplate,
        Messagingtemplates,
    },
    props: {
        sendUserSurvey: {
            type: String,
            default: "",
            required: false,
        },
        messageSubject: {
            type: String,
            default: "",
            required: false,
        },
        messageContent: {
            type: String,
            default: "",
            required: false,
        },
        to: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            form: {
                from: "practice",
                replyTo: "practice",
                deliveryType: "email",
                subject: "",
                content: "",
                fileData: [],
            },
            file: null,
            fileLists: [],
            login: this.$store.getters["currentUser/getCurrentUsersLogin"],
            practice:
                this.$store.getters["currentUser/getCurrentUsersPractice"],
            tokens: [
                {
                    value: "{FIRST}",
                    label: "First Name",
                },
                {
                    value: "{LAST}",
                    label: "Last Name",
                },
                {
                    value: "{LOGIN}",
                    label: "Login",
                },
                {
                    value: "{EMAIL}",
                    label: "Email",
                },
                {
                    value: "{LAST_LOGIN}",
                    label: "Last Login",
                },
                {
                    value: "template",
                    label: "Template",
                },
            ],
            currentToken: "",
            templateModal: false,
            templates: [],
            errorMessage: "",
        };
    },
    computed: {
        toField() {
            return this.to.join(", ");
        },
    },
    methods: {
        async sendMessage() {
            var t = this;
            for (var i = 0; i < t.fileLists.length; i++) {
                this.file = this.fileLists[i];
                var selectedFileString = await this.getBase64StringFromFile();
                selectedFileString = selectedFileString.substr(
                    selectedFileString.indexOf(",") + 1
                );

                var fileDet = {
                    uploadString: selectedFileString,
                    fileName: this.file.name,
                    login: t.login,
                    practiceCode: t.practice,
                    forEmail: true,
                };

                this.form.fileData.push(fileDet);
            }
            this.$emit("sendMessage", this.form);
            this.$refs.textEditor.clearContent();
        },

        getTextEditorContent() {
            return this.messageContent;
        },
        insertToken() {
            if (this.currentToken == "template") {
                this.templateModal = true;
            } else {
                this.$refs.textEditor.append(this.currentToken);
            }
        },
        attachFile: function () {
            document.getElementById("file").click();
        },
        handleFileUpload: async function () {
            var input = document.getElementById("file");
            for (var i = 0; i < input.files.length; ++i) {
                this.file = this.$refs.file.files[i];
                this.fileLists.push(this.file);
            }
        },
        RemoveFile: async function (index) {
            this.fileLists.splice(index, 1);
        },
        getBase64StringFromFile: async function () {
            return new Promise((resolve) => {
                var base64String;
                var reader = new FileReader();
                reader.readAsDataURL(this.file);
                reader.onloadend = function () {
                    base64String = reader.result;
                    resolve(base64String);
                };
            });
        },
        async getMessagetemplate() {
            this.templates = [];
            var data = await Messagingtemplates.GetMessagingTemplateList(
                this.practice
            );
            this.templates = data.result;
            if (this.templates.length == 0) {
                this.errorMessage = "No template found!";
            }
        },
        selectedTemplate(tmpl) {
            this.templates.filter((x) => {
                if (x.id == tmpl) {
                    this.$refs.textEditor.append(x.template_message);
                    this.form.subject = x.template_name;
                    this.templateModal = false;
                }
            });
        },
        async DeleteMessagingTemplate(id) {
            var result = await Messagingtemplates.DeleteMessagingTemplate(id);
            if (result.result) {
                this.$notify({
                    title: "Template is deleted!",
                    horizontalAlign: "left",
                    verticalAlign: "bottom",
                    type: "success",
                    timeout: 3000,
                    showClose: false,
                });
                await this.getMessagetemplate();
            } else {
                this.$notify({
                    title: "Something went wrong!",
                    horizontalAlign: "left",
                    verticalAlign: "bottom",
                    type: "error",
                    timeout: 3000,
                    showClose: false,
                });
                await this.getMessagetemplate();
            }
        },
        async regreshTemplateListData(mesg) {
            if (mesg == "data saved") {
                await this.getMessagetemplate();
            }
        },
    },
    mounted() {
        if (this.messageSubject != "") {
            this.form.subject = this.messageSubject;
        }
    },
    async beforeMount() {
        await this.getMessagetemplate();
    },
};
</script>
<style scoped>
.insertTokenContainer {
    float: right;
}
.insertTokenLabel {
    white-space: nowrap;
    display: inline;
    margin-right: 10px;
}
.divblock {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
}
.fileDisplayDiv {
    display: flex;
    height: 40px;
}
</style>
